module.exports = function MissingArgumentError( message ) {
	Error.captureStackTrace( this, this.constructor );
	this.name = this.constructor.name;
	this.message = message;
};

require( "util" ).inherits( module.exports, Error );



// WEBPACK FOOTER //
// ./node_modules/yoastseo/js/errors/missingArgument.js